import React from 'react';
import { Card } from '@material-ui/core';
import styled from 'styled-components';

const StyledCard = styled(Card)`
  padding: 12px 16px;
  border-radius: 10px !important;
  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.08);
`;

const Label = styled.div`
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: rgba(0, 0, 0, 0.54);
  margin-bottom: 4px;
`;

const ValueRow = styled.div`
  display: flex;
  align-items: baseline;
`;

const Value = styled.span`
  font-size: 24px;
  font-weight: 600;
  color: #212121;
`;

const Unit = styled.span`
  margin-left: 4px;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.54);
`;

function formatValue(value) {
  if (value === null || value === undefined) return '-';
  if (typeof value === 'number') {
    return value.toLocaleString('pt-BR', { maximumFractionDigits: 2 });
  }
  return value;
}

const KpiCard = ({ label, value, unit }) => {
  const formatted = formatValue(value);

  return (
    <StyledCard elevation={1}>
      <Label>{label}</Label>
      <ValueRow>
        <Value>{formatted}</Value>
        {unit && <Unit>{unit}</Unit>}
      </ValueRow>
    </StyledCard>
  );
};

export default KpiCard;
